import { transferOrderFileIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deleteTransferFile = {
  name: "deleteTransferFile" as const,
  input: z.object({ fileId: transferOrderFileIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
